import React, { useEffect, useRef, useState } from 'react';
import ReCAPTCHA from "react-google-recaptcha";
import { useMediaQuery } from "react-responsive";

const tabs = [
    { id: 'sf', label: 'Seamless & Faster', img: '/assets/images/kwikwoocomm/s-and-f.png' },
    { id: 'advdis', label: 'Advanced Discounts', img: '/assets/images/kwikwoocomm/advdis.png' },
    { id: 'rtofear', label: 'COD without RTO fears', img: '/assets/images/kwikwoocomm/rtofear.png' },
    { id: 'abtest', label: 'A/B test to optimize', img: '/assets/images/kwikwoocomm/abtest.png' }
];




const tabsmob = [
    { id: 'sf', label: 'Seamless & Faster', img: '/assets/images/kwikwoocomm/s-and-m-mob.png' },
    { id: 'advdis', label: 'Advanced Discounts', img: '/assets/images/kwikwoocomm/discount-mob.png' },
    { id: 'rtofear', label: 'COD without RTO fears', img: '/assets/images/kwikwoocomm/rto-mob.png' },
    { id: 'abtest', label: 'A/B test to optimize', img: '/assets/images/kwikwoocomm/abtest-mob.png' }
];


const SectionFour: React.FC<any> = () => {
    const isMobile = useMediaQuery({ maxWidth: 768 });
    // const [activeTab, setActiveTab] = useState(tabsmob[0].id);
    const sectionRefs = useRef({});
    const containerRef = useRef<HTMLDivElement>(null);
    const tabsRef = useRef(null);
    // Setup refs for each image section
    // useEffect(() => {
    //     sectionRefs.current = tabsmob.reduce((acc, tab) => {
    //         acc[tab.id] = React.createRef();
    //         return acc;
    //     }, {});
    // }, []);

    // useEffect(() => {
    //     const observer = new IntersectionObserver(
    //         (entries) => {
    //             entries.forEach((entry) => {
    //                 if (entry.isIntersecting) {
    //                     const id = entry.target.getAttribute("data-id");
    //                     if (id) {
    //                         setActiveTab(id);
    //                         const tabElement = document.getElementById(`tab-${id}`);
    //                         tabElement?.scrollIntoView({ behavior: 'smooth', inline: 'center' });
    //                     }
    //                 }
    //             });
    //         },
    //         {
    //             root: containerRef.current,
    //             threshold: 0.6,
    //         }
    //     );

    //     tabsmob.forEach((tab) => {
    //         const section = sectionRefs.current[tab.id]?.current;
    //         if (section) observer.observe(section);
    //     });

    //     return () => observer.disconnect();
    // }, []);
    // // const [activeTab, setActiveTab] = useState('sf');

    // const scrollToSection = (id) => {
    //     sectionRefs.current[id]?.current?.scrollIntoView({
    //         behavior: 'smooth',
    //         block: 'start',
    //     });
    // };

    const [activeTab, setActiveTab] = useState(tabsmob[0].id); // default to first tab



    const scrollToTop = () => window.scrollTo({ top: 0, behavior: 'smooth' });

    return (
        <div className="plugin-banner-sec-four position-relative overflow-hidden">
            <div className="sectionke-sec-four" style={{ minHeight: isMobile ? "auto" : "100vh" }}>
                <div className="head-sec-four">
                    <h1>Launch a Fast and High-Converting Checkout Plugin</h1>
                </div>
                <div>
                    {
                        isMobile ? (
                            <div>
                                <div className="btn-section-four-mob" ref={tabsRef}>
                                    {tabsmob.map((tab) => (
                                        <div
                                            id={`tab-${tab.id}`}
                                            key={tab.id}
                                            className={`card-btn-mob ${activeTab === tab.id ? 'active' : ''}`}
                                            onClick={() => setActiveTab(tab.id)} // set active tab
                                        >
                                            {tab.label}
                                        </div>
                                    ))}
                                </div>

                                <div className="sect-4-cards-mob" ref={containerRef}>
                                    {tabsmob
                                        .filter((tab) => tab.id === activeTab) // only show selected tab
                                        .map((tab) => (
                                            <div
                                                key={tab.id}
                                                className="card-img-mob active"
                                            >
                                                <img src={tab.img} alt={tab.label} />
                                            </div>
                                        ))}
                                </div>
                            </div>
                        ) : (

                            <div>
                                <div className="btn-section-four">
                                    {tabs.map(tab => (
                                        <div
                                            key={tab.id}
                                            id={tab.id}
                                            className={`card-btn ${activeTab === tab.id ? 'active' : ''}`}
                                            onClick={() => setActiveTab(tab.id)}
                                        >
                                            {tab.label}
                                        </div>
                                    ))}
                                </div>

                                <div className="sect-4-cards">
                                    {tabs.map(tab => (
                                        <div
                                            key={tab.id}
                                            className={`card-img ${activeTab === tab.id ? 'active' : ''}`}
                                        >
                                            <img src={tab.img} alt={tab.label} />
                                        </div>
                                    ))}
                                </div>
                            </div>
                        )
                    }
                </div>

                <div className="golive-sec4">
                    <h1>Go live in Minutes!</h1>
                    {/* {
                        !isMobile ? (
                            <div className="fea-golive-sec4">
                                <p style={{ borderRight: "2px solid white", paddingRight: "10px", alignItems: 'center', height: "30px", paddingLeft: "10px" }}>No dev time</p>
                                <p style={{ borderRight: "2px solid white", paddingRight: "10px", alignItems: 'center', height: "30px", paddingLeft: "10px" }}>No tech delays</p>
                                <p style={{ paddingRight: "10px", alignItems: 'center', height: "30px", paddingLeft: "10px" }}>Just plug and play</p>
                            </div>
                        ) : (
                            <div>
                                <div className="fea-golive-sec4">
                                    <p style={{ borderRight: "2px solid white", paddingRight: "10px", alignItems: 'center', height: "13px", paddingLeft: "10px" }}>No dev time</p>
                                    <p style={{ paddingRight: "10px", alignItems: 'center', height: "20px", paddingLeft: "10px" }}>No tech delays</p>
                                </div>
                                <div className="fea-golive-sec4" style={{ justifyContent: 'center' }}>
                                    <p style={{ paddingRight: "10px", alignItems: 'center', height: "20px", paddingLeft: "10px" }}>Just plug and play</p>
                                </div>
                            </div>

                        )
                    } */}

                    <div className="fea-golive-sec4">
                        <p style={{ borderRight: "2px solid white", paddingRight: "10px", alignItems: 'center', height: !isMobile && "30px", paddingLeft: "10px" }}>No dev time</p>
                        <p style={{ borderRight: "2px solid white", paddingRight: "10px", alignItems: 'center', height: !isMobile && "30px", paddingLeft: "10px" }}>No tech delays</p>
                        <p style={{ paddingRight: "10px", alignItems: 'center', height:!isMobile &&"30px", paddingLeft: "10px" }}>Just plug and play</p>
                    </div>




                    <button onClick={scrollToTop} className="cta-sec-4 flex items-center gap-2">
                        Book a Demo
                    </button>

                </div>


                <div className='woo-network-sec4' style={{ padding: isMobile && "0px" }}>
                    <h1 style={{ lineHeight: "1.3" }}>Not Just a Plugin But Your <span style={{ border: '3px solid #0285FB', borderRadius: "15px", padding: '0px 5px', boxShadow: "0px 4px 20px 0px #0285fbad" }}>D2C Growth Engine</span></h1>
                    {/* <p>Access the largest network of online shoppers to boost engagement and conversions</p> */}

                    <div className='woo-net-card'>
                        <div className='outer-sec4'>
                            <div className='inner-sec4 woo-net-card1'>
                                <img src="/assets/images/kwikwoocomm/frame1-sec4.png" alt="" />
                                <div>
                                    <h5>Optimize Shipping Rules</h5>
                                    <p>Set fees & methods based on cart value, payment type, or pincode
                                        — no code required.</p>
                                    <div className="flex" style={{ flexDirection: "column", marginTop: '15px' }}>
                                        <div className="flex pointer-sec4">
                                            <img src="/assets/images/kwikwoocomm/check-sec4.png" alt="" />
                                            <p>Pincode-level rules</p>
                                        </div>
                                        <div className="flex pointer-sec4 ">
                                            <img src="/assets/images/kwikwoocomm/check-sec4.png" alt="" />
                                            <p>Order-range-based methods</p>
                                        </div>
                                        <div className="flex pointer-sec4">
                                            <img src="/assets/images/kwikwoocomm/check-sec4.png" alt="" />
                                            <p>Static EDD support</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='outer-sec4'>
                            <div className='inner-sec4 woo-net-card2'>
                                <img src="/assets/images/kwikwoocomm/frame2-sec4.png" alt="" />
                                <div>
                                    <h5>Flexible Payment Options</h5>
                                    <p>From UPI to No Cost EMI, support every mode that converts.</p>
                                    <div className="flex" style={{ flexDirection: "column", marginTop: '15px' }}>
                                        <div className="flex pointer-sec4">
                                            <img src="/assets/images/kwikwoocomm/check-sec4.png" alt="" />
                                            <p>UPI, Credit/Debit Cards, Net Banking, COD</p>
                                        </div>
                                        <div className="flex pointer-sec4 ">
                                            <img src="/assets/images/kwikwoocomm/check-sec4.png" alt="" />
                                            <p>Buy Now, Pay Later — Snapmint, Simpl</p>
                                        </div>
                                        <div className="flex pointer-sec4">
                                            <img src="/assets/images/kwikwoocomm/check-sec4.png" alt="" />
                                            <p>No Cost EMI + Instant discounts</p>
                                        </div>
                                        <div className="flex pointer-sec4">
                                            <img src="/assets/images/kwikwoocomm/check-sec4.png" alt="" />
                                            <p>All major bank offers supported</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='outer-sec4'>
                            <div className='inner-sec4 woo-net-card3'>
                                <img src="/assets/images/kwikwoocomm/frame3-sec4.png" alt="" />
                                <div>
                                    <h5>Automate Cart Recovery</h5>
                                    <p>With KwikEngage, send automated cart reminders on WhatsApp and boost conversions....</p>
                                    <div className="flex" style={{ flexDirection: "column", marginTop: '15px' }}>
                                        <div className="flex pointer-sec4">
                                            <img src="/assets/images/kwikwoocomm/check-sec4.png" alt="" />
                                            <p>Automated WhatsApp flows</p>
                                        </div>
                                        <div className="flex pointer-sec4 ">
                                            <img src="/assets/images/kwikwoocomm/check-sec4.png" alt="" />
                                            <p>Higher open & recovery rates</p>
                                        </div>
                                        <div className="flex pointer-sec4">
                                            <img src="/assets/images/kwikwoocomm/check-sec4.png" alt="" />
                                            <p>Boost repeat purchases</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>


            </div>
        </div >

    );
}
export default SectionFour